import { render, staticRenderFns } from "./StartSession.vue?vue&type=template&id=f70f9448&scoped=true&"
import script from "./StartSession.vue?vue&type=script&lang=ts&"
export * from "./StartSession.vue?vue&type=script&lang=ts&"
import style0 from "./StartSession.vue?vue&type=style&index=0&id=f70f9448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70f9448",
  null
  
)

component.options.__file = "StartSession.vue"
export default component.exports